import { useState, useEffect } from "react";

import styles from "./progress-circle.module.scss";

function ProgressCircle({
  diameter = 75,
  strokeWidth = 6,
  percentage,
  color = "#0046aa",
}) {
  const cxcy = diameter / 2;
  const radius = cxcy - strokeWidth / 2;
  const dashArray = 2 * Math.PI * radius;
  // strokeWidth / 2 + 1 reduces the progress circle by roughly the width of the curved end
  const dashOffset = percentage
    ? dashArray * (1 - percentage) + (strokeWidth / 2 + 1)
    : dashArray;
  const [animatedOffset, setAnimatedOffset] = useState(dashArray);
  useEffect(() => {
    // this is a bit gross but it forces the animation to occur
    setTimeout(() => setAnimatedOffset(dashOffset));
  }, [dashOffset]);

  return (
    <div style={{ height: diameter, width: diameter }}>
      <svg
        className={styles.progress}
        transform="rotate(-89)"
        width={diameter}
        height={diameter}
        viewBox={`0 0 ${diameter} ${diameter}`}
      >
        <circle
          cx={cxcy}
          cy={cxcy}
          r={radius}
          fill="none"
          stroke="#e1e1e1"
          strokeWidth={strokeWidth}
        />

        {/* rect is used to cover one end of the progress circle */}
        {animatedOffset !== dashArray && (
          <>
            <circle
              className={styles.value}
              style={{
                transition: `stroke-dashoffset ${percentage}s ease-in-out`,
              }}
              cx={cxcy}
              cy={cxcy}
              r={radius}
              fill="none"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeDasharray={dashArray}
              strokeDashoffset={animatedOffset}
            />
            <rect
              x={diameter - strokeWidth}
              y={cxcy - strokeWidth / 2}
              width={strokeWidth}
              height={strokeWidth / 2 + 1}
              fill={color}
            />
          </>
        )}
      </svg>
    </div>
  );
}

export { ProgressCircle };
